// extracted by mini-css-extract-plugin
module.exports = {"result":"SubscriptionSuccessPage_result__2E3c5","image":"SubscriptionSuccessPage_image__2IaJN","next":"SubscriptionSuccessPage_next__2SNSa"};